// Тестовые данные для локального просмотра схемы, когда сервер клуба недоступен.
const busyNumbers = [8, 9, 10, 17, 18, 19, 21, 28, 34, 37, 38, 44, 47, 48, 49, 50, 51, 55, 57];
const warningNumbers = [28];
const blockedNumbers = [45, 46];
const noLimitNumbers = [31, 40];
// ^ активная сессия без остатка времени → фиолетовый статус на схеме

const mockComputerList = Array.from({ length: 58 }, (_, i) => {
    const number = i + 1;

    if (blockedNumbers.includes(number)) {
        return { id: number, number, state: 2, activeSession: null };
    }

    if (noLimitNumbers.includes(number)) {
        return {
            id: number,
            number,
            state: 1,
            activeSession: { hostId: number, userId: number, remainingMinutes: 0 },
        };
    }

    if (warningNumbers.includes(number)) {
        return {
            id: number,
            number,
            state: 1,
            activeSession: { hostId: number, userId: number, remainingMinutes: 900 },
        };
    }

    if (busyNumbers.includes(number)) {
        return {
            id: number,
            number,
            state: 1,
            activeSession: { hostId: number, userId: number, remainingMinutes: 5400 },
        };
    }

    return { id: number, number, state: 1, activeSession: null };
});

export default mockComputerList;
